import { Component } from '@angular/core';
import { DcrKeyValue } from '@ddt-web/config';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-community';

@Component({
	selector: 'ac-loading-overlay',
	template: `
     <div class="ag-overlay-loading-center">
		<div class="text-16" [dcrHTMLKey]="params.loadingMessage.dcrKey">{{params.loadingMessage.dcrValue}}</div>
		<ac-loading-dialog></ac-loading-dialog>
     </div>
   `
})
export class LoadingOverlayComponent implements ILoadingOverlayAngularComp {
	public params: ILoadingOverlayParams & { loadingMessage: DcrKeyValue };
	public loadingMessage: string;

	public agInit(params: ILoadingOverlayParams & { loadingMessage: DcrKeyValue }): void {
		this.params = params;
	}
}
